import useGlobalStore from '@/store/useGlobalStore'
import React from 'react'
import { cn } from '@/lib/utils'
import Spinner from '../Spinner'

const LoadingOverlay = () => {
  const {
    app: { isLoading },
  } = useGlobalStore()

  return (
    <div
      className={cn(
        'fixed left-0 top-0 flex h-screen w-screen items-center justify-center bg-black bg-opacity-50 transition-all duration-500 ease-in-out',
        isLoading ? 'opacity-100' : 'opacity-0',
        isLoading ? 'pointer-events-auto' : 'pointer-events-none',
      )}
      style={{ zIndex: 9999 }}
    >
      <div
        className={cn(
          `flex h-[80px] w-[80px] items-center justify-center rounded-lg bg-white transition-all duration-500 ease-in-out`,
          isLoading ? 'scale-100' : 'scale-0',
        )}
      >
        <Spinner size={42} />
      </div>
    </div>
  )
}

export default LoadingOverlay
